module.exports = __webpack_public_path__ + "img/banner1.1828775d.png";